import { showToast } from '@Sage/hoi-poi-ui';
import { t } from 'utils/getLiteral';

export const successToast = (label, params) => {
    const msg = label ? t(label, [params]) : t('cfm_label_success_action');
    return showToast({
        type: 'success',
        title: t('cfm_label_success'),
        text: msg,
        useDefaultCloseButton: true,
    });
};

export const errorToast = (label, params, text) => {
    const msg = label ? t(label, [params]) : t('cfm_label_error_action');
    return showToast({
        type: 'error',
        title: msg,
        text: text,
        useDefaultCloseButton: true,
    });
};

export const infoToast = (label, params) => {
    const msg = label ? t(label, [params]) : t('cfm_label_info_action');
    return showToast({
        type: 'info',
        title: msg,
        useDefaultCloseButton: true,
    });
};
